import { render, staticRenderFns } from "./AdReport.vue?vue&type=template&id=70687c93&"
import script from "./AdReport.vue?vue&type=script&lang=js&"
export * from "./AdReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports